/**
 * Geometrie der Achsen, ohne React.
 *
 * Eigene Datei, weil sich das hier einzeln testen lässt und weil eine
 * Komponentendatei nur Komponenten exportieren soll.
 */

/**
 * Welche Punkte eine Beschriftung an der X-Achse bekommen.
 *
 * Der letzte Punkt ist immer dabei, denn wann ein Verlauf endet, ist
 * die Frage, die man an ihn stellt. Läge er zu dicht am vorherigen
 * beschrifteten Punkt, verdrängt er ihn, statt sich danebenzustellen.
 * Zwei überlappende Monatsnamen sind unlesbar und sehen dabei nicht
 * nach einem Fehler aus, sondern nach schlechten Daten.
 */
export function labelledIndices(count: number): readonly number[] {
  if (count <= 0) return []

  const step = Math.max(1, Math.ceil(count / 6))
  const indices: number[] = []
  for (let index = 0; index < count - 1; index += step) {
    indices.push(index)
  }

  const last = count - 1
  const previous = indices[indices.length - 1]
  if (previous !== undefined && last - previous < step) {
    indices.pop()
  }
  indices.push(last)

  return indices
}
